import ActionButton from 'components/ActionButton';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import qs from 'query-string';

const Filter = props => {
  const [featuredLists, setFeaturedLists] = useState('');
  const [publicLists, setPublicLists] = useState('');

  useEffect(() => {
    const {
      isFeatured,
      isPublic,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    if (isFeatured) setFeaturedLists(`${isFeatured}`);
    if (isPublic) setFeaturedLists(`${isPublic}`);
  }, []);


  const resetFilter = () => {
    setFeaturedLists('');
    setPublicLists('');
    props.onSubmit({});
  };

  const handleSubmit = () => {

    let filterData: any = {
      isFeatured: featuredLists ? JSON.parse(featuredLists) : '',
      isPublic: publicLists ? JSON.parse(publicLists) : '',
    };
    filterData = _.omitBy(filterData, (v) => _.isUndefined(v) || _.isNull(v) || v === '');
    props.onSubmit(filterData);
  };

  const publicDropdown = () => {
    return (
      <div className={styles['input-group']}>
        <div className={styles['label']}>Public{publicLists}</div>
        <select
          value={publicLists}
          className={'form-control'}
          onChange={e => setPublicLists(e.target.value)}
        >
          <option value={''}>All</option>
          <option value={'true'}>Public</option>
          <option value={'false'}>Non-public</option>
        </select>
      </div>
    );
  };

  const featuredDropdown = () => {
    return (
      <div className={styles['input-group']}>
        <div className={styles['label']}>Featured{featuredLists}</div>
        <select
          value={featuredLists}
          className={'form-control'}
          onChange={e => setFeaturedLists(e.target.value)}
        >
          <option value={''}>All</option>
          <option value={'true'}>Featured</option>
          <option value={'false'}>Non-featured</option>
        </select>
      </div>
    );
  };
  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-container']}>
        {publicDropdown()}
        {featuredDropdown()}
      </div>

      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;